import React from "react";
import { Paper } from "@mui/material";
import { WebsitesMap } from "./websites/WebsitesMap";
import { RedirectGuides } from "./websites/RedirectGuides";

// Loacker websites: where the domains and their redirects live, and step-by-step guides for IT
export const LoackerWebsites = () => (
  <Paper sx={{ p: 2, width: "100%" }}>
    <WebsitesMap />
    <RedirectGuides />
  </Paper>
);
